import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Add from "./pages/Add";
import Books from "./pages/Books";
import Update from "./pages/Update";
import Delete from "./pages/Delete";
import Admin from "./pages/Admin";
import AdminProduct from "./pages/AdminProduct";
import AdminUser from "./pages/AdminUser";
import Detail from "./pages/Detail";
import Order from "./pages/Order";
import AdminOrder from "./pages/AdminOrder";
import SalesPanel from "./pages/SalesPanel";
import BuyingPanel from "./pages/BuyingPanel";
import Msg from "./pages/Msg";
import Help from "./pages/Help";
import AdminMessage from "./pages/AdminMessage";

/**
 * ProtectedRoute Component
 * Uses the same logic as your Books.js file
 */
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  
  // If logged in, show the page. If not, redirect to Home ("/")
  return isLoggedIn ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          {/* --- PUBLIC ROUTES (Visible to everyone) --- */}
          <Route path="/" element={<Books />} />
          <Route path="/detail/:id" element={<Detail />} />

          {/* --- PROTECTED ROUTES (Requires isLoggedIn === "true") --- */}
          <Route path="/add" element={<ProtectedRoute><Add /></ProtectedRoute>} />
          <Route path="/update/:id" element={<ProtectedRoute><Update /></ProtectedRoute>} />
          <Route path="/delete/:id" element={<ProtectedRoute><Delete /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/adminproduct" element={<ProtectedRoute><AdminProduct /></ProtectedRoute>} />
          <Route path="/adminuser" element={<ProtectedRoute><AdminUser /></ProtectedRoute>} />
          <Route path="/adminorder" element={<ProtectedRoute><AdminOrder /></ProtectedRoute>} />  
          <Route path="/salespanel" element={<ProtectedRoute><SalesPanel /></ProtectedRoute>} />  
          <Route path="/buyingpanel" element={<ProtectedRoute><BuyingPanel /></ProtectedRoute>} />  
          <Route path="/adminmessage" element={<ProtectedRoute><AdminMessage /></ProtectedRoute>} />

          <Route path="/msg" element={<Msg />} />
          <Route path="/order/:productId" element={<Order />} />
          <Route path="/help" element={<Help />} />
          
          {/* CATCH-ALL: Redirect any invalid URL to Home */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
